import coreStore from './core-store'

const remoteResource = 'party/api/v1/parties';

export default coreStore.createCoreStore('party', remoteResource, 'parties');